
  var classes = [];
  module.exports = classes;




// WEBPACK FOOTER //
// ./project/client/src/core/vendor/browsernizr/lib/classes.js